import Field from './Field';
import Form from './Form';

const IProperty = {
  ...Field,
  ...Form,
} as const;

export default IProperty;
